export default __webpack_public_path__ + "static/media/moscow-method.3d3d10b2.pptx";